module.exports = __webpack_public_path__ + "img/weya2.f4ce02f0.png";